import { FileExclamationFilled } from "@ant-design/icons";
import { faCheckCircle, faFileCircleMinus, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip, Typography } from "antd";
import React from "react";
import DataPreviewTable, { IDataPreviewDataType } from "./DataPreviewTable";
import "./style.css";

export default function DataPreview({
    onClose,
    columns,
    data,
    title = "Data Preview (100 Records)",
    subtitle,
    dataSchemaColumns = [],
    className = "",
    closeLabel,
    closeTooltip,
    transposed = false,
}: IDataPreviewProps) {
    const headers = React.useMemo(() => {
        const columnHeaders: IDataPreviewDataType = {};
        columns.map(
            (column) =>
                (columnHeaders[column] = (
                    <>
                        {column}
                        {dataSchemaColumns &&
                            (dataSchemaColumns.findIndex((item) => item.toLowerCase() === column.toLowerCase()) > -1 ? (
                                <FontAwesomeIcon icon={faCheckCircle} className="ml-1 text-green-600" />
                            ) : (
                                <FontAwesomeIcon icon={faTimesCircle} className="ml-1 text-red-600" />
                            ))}
                    </>
                )),
        );

        return columnHeaders;
    }, [columns, dataSchemaColumns]);

    return (
        <div className={["flex size-full flex-1 flex-col", className].join(" ")}>
            <div className="flex flex-row items-center justify-between">
                <Typography.Title level={3} className="!mb-0">
                    {title}
                </Typography.Title>
                {onClose && (
                    <Tooltip placement="topRight" title={closeTooltip}>
                        <Button danger onClick={onClose} type="primary" size="small" icon={<FontAwesomeIcon icon={faFileCircleMinus} />}>
                            {closeLabel}
                        </Button>
                    </Tooltip>
                )}
            </div>
            {subtitle && <Typography.Text type="secondary">{subtitle}</Typography.Text>}
            {data && data.length > 0 ? (
                <div className="scroll-webkit mt-2 w-full flex-1 overflow-auto border border-slate-100">
                    <DataPreviewTable headers={headers} rows={data} transposed={transposed} />
                </div>
            ) : (
                <div className="flex w-full flex-1 flex-col items-center justify-center overflow-auto border border-dashed border-slate-300">
                    <FileExclamationFilled className="mb-3 text-3xl text-slate-500" />
                    <p className="text-sm">No data found</p>
                </div>
            )}
        </div>
    );
}
